import * as React from 'react';

import Link from 'next/link';

type UpcomingEventProps = {
    header: string;
    title: string;
    description: string;
    location: string;
    date: string;
    learnMoreUrl: string;
    registerUrl: string;
    className?: string;
};

const UpcomingEvent = (props: UpcomingEventProps) => {
    const { className, header, title, description, location, date, learnMoreUrl, registerUrl } = props;

    return (
        <div className={className}>
            <div className="flex justify-start items-center px-10 py-5 w-full border-b">
                <div className="gap-2.5">
                    <p className="font-normal text-left uppercase text-dark">{header}</p>
                </div>
            </div>
            <div className="flex flex-col justify-start items-start gap-3 p-10 border-t-0 border-r-0 border-b border-l-0 border-[#b4b4b4]/[0.35]">
                <div className="flex flex-col justify-start items-start gap-2">
                    <div className="flex justify-start items-start relative gap-2.5">
                        <p className="flex-grow text-2xl text-left font-semibold text-dark">
                            <Link href={learnMoreUrl} passHref>
                                {title}
                            </Link>
                        </p>
                    </div>
                    <div className="flex flex-col justify-start relative gap-2 text-gray-700">
                        <div className="flex justify-start items-center relative gap-1">
                            <svg
                                width="8"
                                height="10"
                                viewBox="0 0 8 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="flex-grow-0 flex-shrink-0"
                                preserveAspectRatio="xMidYMid meet"
                            >
                                <path
                                    d="M6.65685 6.65685C6.03287 7.28084 4.31371 9 4.31371 9C4.31371 9 2.64066 7.32695 1.97056 6.65685C0.676479 5.36277 0.676479 3.26465 1.97056 1.97056C3.26465 0.676479 5.36277 0.676479 6.65685 1.97056C7.95094 3.26465 7.95094 5.36277 6.65685 6.65685Z"
                                    stroke="#111827"
                                    strokeWidth="0.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M5.55635 4.31371C5.55635 5 5 5.55635 4.31371 5.55635C3.62742 5.55635 3.07107 5 3.07107 4.31371C3.07107 3.62742 3.62742 3.07107 4.31371 3.07107C5 3.07107 5.55635 3.62742 5.55635 4.31371Z"
                                    stroke="#111827"
                                    strokeWidth="0.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <div className="flex justify-start items-center relative gap-1">
                                <p className="text-sm text-left uppercase">{location}</p>
                            </div>
                        </div>
                        <div className="flex justify-start items-center relative gap-1">
                            <svg
                                width="9"
                                height="10"
                                viewBox="0 0 9 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="flex-grow-0 flex-shrink-0"
                                preserveAspectRatio="xMidYMid meet"
                            >
                                <path
                                    d="M2.84918 2.77778V1M6.40473 2.77778V1M2.40473 4.55556H6.84918M1.51584 9H7.73806C8.22898 9 8.62695 8.60203 8.62695 8.11111V2.77778C8.62695 2.28686 8.22898 1.88889 7.73806 1.88889H1.51584C1.02492 1.88889 0.626953 2.28686 0.626953 2.77778V8.11111C0.626953 8.60203 1.02492 9 1.51584 9Z"
                                    stroke="#110B29"
                                    strokeWidth="0.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <div className="flex justify-start items-center relative gap-1">
                                <p className="text-sm text-left uppercase">{date}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-start items-start self-stretch relative gap-2.5">
                    <p className="flex-grow text-lg text-left text-dark">{description}</p>
                </div>
                <div className="flex justify-start items-start self-stretch gap-3">
                    {learnMoreUrl && (
                        <Link href={learnMoreUrl} passHref>
                            <a className="flex justify-start items-center relative gap-0.5">
                                <div className="flex justify-start items-center relative gap-1">
                                    <p className="text-base text-left uppercase text-[#5637cd]">learn more</p>
                                </div>
                                <svg
                                    width="10"
                                    height="10"
                                    viewBox="0 0 10 10"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="w-2.5 h-2.5 relative"
                                    preserveAspectRatio="xMidYMid meet"
                                >
                                    <path
                                        d="M6.67116 4.58325H1.66699V5.41659H6.67116V6.66659L8.33366 4.99992L6.67116 3.33325V4.58325Z"
                                        fill="#5637CD"
                                    />
                                </svg>
                            </a>
                        </Link>
                    )}
                    {registerUrl && (
                        <Link href={registerUrl}>
                            <a className="flex justify-start items-center relative gap-0.5">
                                <div className="flex justify-start items-center relative gap-1">
                                    <p className="text-base text-left uppercase text-[#5637cd]">register</p>
                                </div>
                                <svg
                                    width="10"
                                    height="10"
                                    viewBox="0 0 10 10"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="w-2.5 h-2.5 relative"
                                    preserveAspectRatio="xMidYMid meet"
                                >
                                    <path
                                        d="M6.67116 4.58325H1.66699V5.41659H6.67116V6.66659L8.33366 4.99992L6.67116 3.33325V4.58325Z"
                                        fill="#5637CD"
                                    />
                                </svg>
                            </a>
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
};

export default UpcomingEvent;
